import { render, staticRenderFns } from "./taskImage.vue?vue&type=template&id=3c5c73de&scoped=true&"
import script from "./taskImage.vue?vue&type=script&lang=js&"
export * from "./taskImage.vue?vue&type=script&lang=js&"
import style0 from "./taskImage.vue?vue&type=style&index=0&id=3c5c73de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c73de",
  null
  
)

export default component.exports